import GoogleTagAdapter from "../GoogleTagAdapter/GoogleTagAdapter";

export default class Tercept {
  static load() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = "async";
    script.src = "https://cdn.tercept.com/js/trcpt?account_id=TCPT-1570";
    script.onload = Tercept.init;

    document.head.appendChild(script);
  }

  static init() {
    const AD_MANAGER_NETWORKS = {
      'nc_video': 95250053,
      'nc_display': 36504930
    };

    window && window.tercept && window.tercept.init && window.tercept.init(AD_MANAGER_NETWORKS);
  }

  static addEventListener() {
    GoogleTagAdapter.push(function() {
      Tercept.addEventListenerRequested();
      Tercept.addEventListenerResponseReceived();
      Tercept.addEventListenerRenderEnded();
      Tercept.addEventListenerImpression();
    });
  }

  static addEventListenerRequested() {
    GoogleTagAdapter.addEventListener('slotRequested', function(event) {
      window && window.tercept && window.tercept.logRequestedEvent && window.tercept.logRequestedEvent(event);
    });
  }

  static addEventListenerResponseReceived() {
    GoogleTagAdapter.addEventListener('slotResponseReceived', function(event) {
      window && window.tercept && window.tercept.logResponseEvent && window.tercept.logResponseEvent(event);
    });
  }

  static addEventListenerRenderEnded() {
    GoogleTagAdapter.addEventListener('slotRenderEnded', function(event) {
      window && window.tercept && window.tercept.logRenderEvent && window.tercept.logRenderEvent(event);
    });
  }

  static addEventListenerImpression() {
    GoogleTagAdapter.addEventListener('impressionViewable', function(event) {
      window && window.tercept && window.tercept.logImpEvent && window.tercept.logImpEvent(event);
    });
  }

  static setTargeting() {
    GoogleTagAdapter.push(function() {
      (window && window.tercept && window.tercept.setTargeting)?(window.tercept.setTargeting(window.kmklabs.gpt.slots)):(window.kmklabs.gpt.slots.forEach(slot => slot.setTargeting('tcpt', ['TCPT_NL'])));
    });
  }
}